import ViewWorkSection from '@Components/ViewWork/ViewWorkSection'
import React, { useContext } from 'react'
import { WorkModel } from '@Entities/work/work'
import WorkMetadataField from '@Components/ViewWork/BasicWorkMetadata/work-metadata-field'
import { StoresContext } from '@App/contexts'
import './index.scss'
import { ZodFormattedError } from 'zod'
import { WorkType } from '@Components/ViewWork/work-type'
import { checkForErrorsInMetadata } from '@App/forms/validation/metadata'
import generateEditLink from '@App/helpers/generate-edit-link'
import AlternativeTitlesTable from '@Components/ViewWork/BasicWorkMetadata/AlternativeTitles'
import { formatLanguage } from '@App/helpers/format-language'
import EditButton from '@Components/ViewWork/EditButton'
import { joinErrors } from '@App/helpers/join-errors'

interface BasicWorkMetadataProps {
    viewWork: WorkModel
    rightsholderId?: number
    editing?: boolean
    workType?: WorkType
    errors?: ZodFormattedError<WorkModel>
}

const BasicWorkMetadata = ({ viewWork, workType, errors, rightsholderId, editing }: BasicWorkMetadataProps) => {
    const { libStore } = useContext(StoresContext)
    const langOptions = libStore.languages

    const workDetailsEditLink = generateEditLink('workDetails', viewWork.id as number, rightsholderId, workType)

    // TODO This isn't ideal, we can't pull out just the base schema - revisit
    const errorInMetadata = checkForErrorsInMetadata(errors)
    const isValid = editing !== undefined ? !errorInMetadata : undefined
    const showMlcSongCode = workType !== 'create-form' && workType !== 'create-wizard'
    const showRefId = workType === 'draft' || workType === 'history'
    const formatedLanguage = formatLanguage(langOptions, viewWork.languageCode)

    return (
        <ViewWorkSection
            valid={isValid}
            icon="workDetails"
            title="Work Detail"
            rightData={
                <>{editing && <EditButton workType={workType} linkTo={workDetailsEditLink} wizardFlowIndex={1} />}</>
            }
        >
            <div className="basic-work-metadata">
                <WorkMetadataField
                    title="Member Work Identifier"
                    value={viewWork.rightsholderProprietaryId}
                    error={joinErrors(errors?.rightsholderProprietaryId?._errors)}
                />
                {showMlcSongCode && (
                    <WorkMetadataField
                        title="MLC Song Code"
                        value={viewWork.songCode}
                        error={joinErrors(errors?.songCode?._errors)}
                    />
                )}
                <WorkMetadataField title="ISWC" value={viewWork.iswc} error={joinErrors(errors?.iswc?._errors)} />
                <WorkMetadataField
                    title="Duration"
                    value={viewWork.duration}
                    default="--:--"
                    error={joinErrors(errors?.duration?._errors)}
                />
                <WorkMetadataField
                    title="Language"
                    value={formatedLanguage}
                    error={joinErrors(errors?.languageCode?._errors)}
                />
                {showRefId && (
                    <WorkMetadataField
                        title="REF ID"
                        value={viewWork.referenceId}
                        error={joinErrors(errors?.referenceId?._errors)}
                    />
                )}
            </div>
            <AlternativeTitlesTable viewWork={viewWork} errors={errors?.alternativeTitles} />
        </ViewWorkSection>
    )
}

export default BasicWorkMetadata
